/** Friendly labels for the operation codes returned by the backend. */
export const OPERATION_LABELS = {
  "student.toggle": "Activar / desactivar alumnos",
  "appointment.delete": "Eliminar citas",
  "class_purchase.create": "Añadir bono de clases",
  "class_purchase.delete": "Eliminar bono de clases",
  "class_adjustment.create": "Ajuste manual del saldo de clases",
  "appointment.add_shared": "Añadir alumno en sesión compartida",
  "vehicle.delete": "Eliminar vehículo",
  "setting.update": "Cambiar configuración",
  "contract.delete": "Eliminar contratos",
  "pack.delete": "Eliminar packs",
  "circuit.delete": "Eliminar circuitos",
  "location.delete": "Eliminar ubicaciones",
  "doc_alert_reason.delete": "Eliminar motivos de alerta",
  "exam_request.delete": "Eliminar solicitudes de examen",
  "exam_request.logistics.edit": "Editar datos logísticos de la solicitud",
  "documents.templates.write": "Editar Matriz Documental",
  "onedrive.read": "Consultar estado de OneDrive",
  "onedrive.write": "Ejecutar test de conexión OneDrive",
};

export const EVENT_LABELS = {
  pin_setup: "PIN configurado",
  pin_change: "PIN cambiado",
  pin_verify_success: "PIN verificado",
  pin_verify_fail: "PIN incorrecto",
  pin_verify_blocked: "Verificación bloqueada",
  pin_locked: "PIN bloqueado",
  pin_recovery_requested: "Recuperación solicitada",
  pin_recovery_used: "PIN restablecido por recuperación",
  pin_recovery_fail: "Código de recuperación incorrecto",
  sudo_used: "Acción sensible autorizada",
  class_adjustment: "Ajuste manual de clases",
};

export function operationLabel(op) {
  return OPERATION_LABELS[op] || op || "esta acción";
}

export function eventLabel(ev) {
  return EVENT_LABELS[ev] || ev;
}
